import { api } from './api'

export interface DashboardMetrics {
  active_projects: number
  pending_reviews: number
  compliance_score: number
  risk_alerts: number
  total_contracts: number
  total_value: number
  active_users: number
  critical_issues: number
}

export interface TrendData {
  date: string
  contracts: number
  compliance: number
  risks: number
}

export interface RiskDistribution {
  name: string
  value: number
  color: string
}

export interface ProjectStatus {
  status: string
  count: number
  color: string
}

export interface RecentActivity {
  id: number
  activity_type: string
  type?: string // 'contract', 'project', 'compliance', etc.
  title: string
  time: string
  user: string
  project_id?: string
}

export interface UpcomingDeadline {
  id: number
  title: string
  due_in: string
  priority: string
  project: string
  project_id?: string
}

export interface DashboardResponse {
  metrics: DashboardMetrics
  trend_data: TrendData[]
  risk_distribution: RiskDistribution[]
  project_status: ProjectStatus[]
  recent_activity: RecentActivity[]
  upcoming_deadlines: UpcomingDeadline[]
}

export const dashboardService = {
  async getDashboard(period?: string): Promise<DashboardResponse> {
    const params = period ? { period } : {}
    const response = await api.get('/dashboard', { params })
    return response.data
  },

  async getMetrics(): Promise<DashboardMetrics> {
    const response = await api.get('/dashboard/metrics')
    return response.data
  },

  async getActivity(): Promise<RecentActivity[]> {
    const response = await api.get('/dashboard/activity')
    return response.data
  },

  async getDeadlines(): Promise<UpcomingDeadline[]> {
    const response = await api.get('/dashboard/deadlines')
    return response.data
  },
}